module.exports = __webpack_public_path__ + "img/symbol_6.eee81ca5.png";